module.exports = __webpack_public_path__ + "static/media/landing.815ee5c2.png";